import React from 'react'
import { Trans } from '@lingui/macro'
import { PriceInfoType } from 'views/utils/propTypes'
import { shape } from 'prop-types'
import { isRequired } from 'views/utils/propTypeUtils'

import './PriceInfo.scss'

const PriceInfo = props => {
  const {
    info: { text, index }
  } = props

  return text ? (
    <span className="u-color--greyLight-dark u-font-weight--normal u-no-margin">
      <Trans id={text} />
      <sup>{index}</sup>:
    </span>
  ) : null
}

PriceInfo.propTypes = {
  info: shape(isRequired(PriceInfoType)).isRequired
}

export default PriceInfo
